module.exports = __webpack_public_path__ + "static/media/can.c356d21e.png";